import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconUser = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'User'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 16 16' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M16.5 -0.666656H15.8333V1.01924e-05H16.5V-0.666656ZM6.11663 7.21668C6.63885 7.7389 7.26663 8.00001 7.99996 8.00001C8.73329 8.00001 9.36107 7.7389 9.88329 7.21668C10.4055 6.69445 10.6666 6.06668 10.6666 5.33334C10.6666 4.60001 10.4055 3.97223 9.88329 3.45001C9.36107 2.92779 8.73329 2.66668 7.99996 2.66668C7.26663 2.66668 6.63885 2.92779 6.11663 3.45001C5.5944 3.97223 5.33329 4.60001 5.33329 5.33334C5.33329 6.06668 5.5944 6.69445 6.11663 7.21668ZM3.05829 12.9417C3.3194 13.2028 3.63329 13.3333 3.99996 13.3333H12C12.3666 13.3333 12.6805 13.2028 12.9416 12.9417C13.2027 12.6806 13.3333 12.3667 13.3333 12V11.4667C13.3333 11.0889 13.2361 10.7417 13.0416 10.425C12.8472 10.1083 12.5888 9.86668 12.2666 9.70001C11.5777 9.35557 10.8777 9.09723 10.1666 8.92501C9.45551 8.75279 8.73329 8.66668 7.99996 8.66668C7.26663 8.66668 6.5444 8.75279 5.83329 8.92501C5.12218 9.09723 4.42218 9.35557 3.73329 9.70001C3.41107 9.86668 3.15274 10.1083 2.95829 10.425C2.76385 10.7417 2.66663 11.0889 2.66663 11.4667V12C2.66663 12.3667 2.79718 12.6806 3.05829 12.9417ZM12 11.4667V12H3.99996V11.4667C3.99996 11.3445 4.03051 11.2333 4.09163 11.1333C4.15274 11.0333 4.23329 10.9556 4.33329 10.9C4.93329 10.6 5.53885 10.375 6.14996 10.225C6.76107 10.075 7.37774 10 7.99996 10C8.62218 10 9.23885 10.075 9.84996 10.225C10.4611 10.375 11.0666 10.6 11.6666 10.9C11.7666 10.9556 11.8472 11.0333 11.9083 11.1333C11.9694 11.2333 12 11.3445 12 11.4667ZM8.94163 6.27501C8.68051 6.53612 8.36663 6.66668 7.99996 6.66668C7.63329 6.66668 7.3194 6.53612 7.05829 6.27501C6.79718 6.0139 6.66663 5.70001 6.66663 5.33334C6.66663 4.96668 6.79718 4.65279 7.05829 4.39168C7.3194 4.13057 7.63329 4.00001 7.99996 4.00001C8.36663 4.00001 8.68051 4.13057 8.94163 4.39168C9.20274 4.65279 9.33329 4.96668 9.33329 5.33334C9.33329 5.70001 9.20274 6.0139 8.94163 6.27501Z"
      />
    </Icon>
  )
}

IconUser.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconUser
